import { createAction, props } from '@ngrx/store';

export const LOAD_AIRPORTLIST = '[Airport List] Load Airport List';
export const LOAD_AIRPORTLIST_SUCCESS =
  '[Airport List] Load Airport List Success';
export const LOAD_AIRPORTLIST_FAILURE =
  '[Airport List] Load Airport List Failure';

export const loadAirportList = createAction(LOAD_AIRPORTLIST);

export const loadAirportListSuccess = createAction(
  LOAD_AIRPORTLIST_SUCCESS,
  props<{ airports: any[] }>()
);

export const loadAirportListFailure = createAction(
  LOAD_AIRPORTLIST_FAILURE,
  props<{ error: any }>()
);
